import axios from '../config/axiosConfig';
import ApiKey from '@/service/constant/ApiKey';
import { BASE_URL, ADMIN_URL } from './constant/BaseApiUrl';

export default class QuoteFeatureService {
  viewQuote(id) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${id}`);
  }
  reQuote(id) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${id}/re-quote`);
  }
  reQuoteWorkSheet(id) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${id}/worksheet/re-quote`);
  }
  viewClientCopy(id) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_CLIENT_COPPY}${id}`);
  }
  submitClientCopy(payload) {
    return axios.post(`${BASE_URL}${ApiKey.SUBMIT_CLIENT_COPY}`, payload);
  }
  viewUrlQuote(id, type) {
    return axios.get(`${ADMIN_URL}${ApiKey.CONFIG_FOR_URL_TYPE}${type}`);
  }
  viewLogRule(id) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${id}/log-rule`);
  }
  updateFlightRule(id, option) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${id}/flight-rule/${option}`);
  }

  updateHotelRule(id, option) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${id}/hotel-rule/${option}`);
  }

  updateTourRule(id: string, mdtOption: number, tourOption: number) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_MDT_QUOTE}${id}/option/${mdtOption}/tour-rule/${tourOption}`);
  }

  updateFlightTourRule(id: string, mdtOption: number, tourOption: number) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_MDT_QUOTE}${id}/option/${mdtOption}/flight-rule/${tourOption}`);
  }

  viewTourLogRule(id: string) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_MDT_QUOTE}${id}/log-rule`);
  }

  viewPDF(id) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}signed/pdf/${id}`);
  }

  previewPDF(id) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${id}/preview-pdf`);
  }

  getRuleAssignment() {
    return axios.get(`${ADMIN_URL}${ApiKey.PACKAGE_RULE}`);
  }

  updateRuleAssignment(payload: any) {
    return axios.put(`${ADMIN_URL}${ApiKey.PACKAGE_RULE}`, payload);
  }

  viewPriceSummary(quoteId: string) {
    return axios.get(`${BASE_URL}${ApiKey.PRICE_SUMMARY}/${quoteId}`);
  }
}
